import { render, staticRenderFns } from "./ButtonModern.vue?vue&type=template&id=29273423&"
import script from "./ButtonModern.vue?vue&type=script&lang=js&"
export * from "./ButtonModern.vue?vue&type=script&lang=js&"
import style0 from "./ButtonModern.vue?vue&type=style&index=0&id=29273423&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports